/**
 * components/ActAsBanner.js — «ДҮР ЭМУЛЭХ» анхааруулах тууз.
 *
 * ⚠ ЯАГААД ЭНЭ ТУУЗ ЗААВАЛ ВЭ:
 *   Дүрд орсны дараа апп нь ТЭР хэрэглэгчийн эрхийг хардаг. Хэрэв гарах
 *   товчийг эрхээр нөхцөлдүүлбэл эрх багатай дүрд орсон хөгжүүлэгч цэс
 *   хоосон, API 403 болсон байдалд ГАЦНА. Тиймээс энэ тууз нь:
 *     · эрх, роль, серверийн хариунаас ҮЛ ХАМААРНА
 *     · зөвхөн localStorage дахь утга байгаа эсэхээс шалтгаална
 *     · гарахдаа сервер рүү ОГТ ХАНДАХГҮЙ, зөвхөн локал утгыг устгана
 *   Ингэснээр ямар ч нөхцөлд буцах зам нээлттэй үлдэнэ.
 *
 * Апп-ын ХАМГИЙН ГАДНА талд (эрхийн шалгалтаас гадуур) байрлуулна.
 */
import React from "react";
import { getActAs, returnToSelf } from "src/utils/actAs";

export default function ActAsBanner() {
  const tn = getActAs();
  if (!tn) return null;

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        flexWrap: "wrap",
        padding: "7px 14px",
        background: "#B91C1C",
        color: "#fff",
        fontSize: 13,
        fontWeight: 600,
        boxShadow: "0 1px 4px rgba(0,0,0,.25)",
      }}
    >
      <span>
        ⚠ Та <b>{tn}</b> дугаартай ажилтны нэрээр нэвтэрсэн байна —
        харагдац, эрх, хийсэн үйлдэл БҮГД түүнийх.
      </span>
      <button
        type="button"
        onClick={returnToSelf}
        style={{
          border: "1px solid rgba(255,255,255,.7)",
          background: "rgba(255,255,255,.15)",
          color: "#fff",
          borderRadius: 6,
          padding: "3px 12px",
          fontSize: 12.5,
          fontWeight: 700,
          cursor: "pointer",
        }}
      >
        Өөрийн бүртгэл рүү буцах
      </button>
    </div>
  );
}
